import { Button, styled } from '@mui/material';

export const StyledDisabledButton = styled(Button)`
  &:disabled {
    color: #fff;
    background-color: #a0bcc6;
    padding: 13px 24px;
  }
`;
